import React from "react";

import StackedCards from "./StackedCards";
import { InfiniteMovingCardsDemo } from "./InfiniteMovingCardsDemo";

const SecondaryContainer = () => {
  return (
    <div > 
    
      <StackedCards/>
      <InfiniteMovingCardsDemo/>
      
    </div>
  );
};

export default SecondaryContainer;
